export default "__VITE_ASSET__00e5397f__"